export default __webpack_public_path__ + "static/media/668.ecdef0f9.png";